if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
        window.dispatchEvent(new Event('resize.resize-select'));
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

        window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let h = this.getBoundingClientRect().top;
        if (h <= 0) {
          this.classList.add('is-sticky');
        } else {
          this.classList.remove('is-sticky');
        }
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const isOpen = detailsElement.hasAttribute('open');
      if (isOpen) {
        detailsElement.classList.remove('submenu-open');
      } else {
        detailsElement.classList.add('submenu-open');
      }
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('submenu-open');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();

      this.submenus = this.querySelectorAll('.thb-full-menu .menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu');
    }
    connectedCallback() {
      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      document.fonts.ready.then(function () {
        window.addEventListener('resize', debounce(function () {
          _this.resizeSubMenus();
        }, 100));
      });

    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(':scope >.menu-item-has-children>.sub-menu');

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l = sub_submenu.parentElement.getBoundingClientRect().left + sub_submenu.parentElement.offsetWidth,
            total = w + l;

          if (total > window.innerWidth) {
            sub_submenu.parentElement.classList.add('left-submenu');
          } else if (sub_submenu.parentElement.classList.contains('left-submenu')) {
            sub_submenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
  }
  customElements.define('full-menu', FullMenu);
}


document.addEventListener('DOMContentLoaded', function () {
    // Add attributes to .shopify-section
    document.querySelectorAll('.shopify-section').forEach((element, index) => {
        element.setAttribute('aria-label', `section(${index + 1})`);
        element.setAttribute('role', 'region');
    });

    // Remove attributes from .footer
    document.querySelectorAll('.shopify-section-group-footer-group, .blog-section').forEach(footer => {
        footer.removeAttribute('aria-label');
        footer.removeAttribute('role');
    });

    // Add attributes to #Product-Drawer
    document.querySelectorAll('#Product-Drawer').forEach(drawer => {
        drawer.setAttribute('aria-label', 'section(product drawer)');
        drawer.setAttribute('role', 'region');
    });
});


document.addEventListener('DOMContentLoaded', function() {
  // Select all images inside .collection-card
  const images = document.querySelectorAll('.collection-card img');

  // Loop through each image and update its alt attribute
  images.forEach(function(image) {
    // Check if the image has an alt attribute before appending the text
    if (image.alt) {
      image.alt = image.alt + ' (collection)';
    } else {
      // If the image does not have an alt attribute, create one
      image.alt = '(collection)';
    }
  });
});


document.addEventListener('DOMContentLoaded', function() {
  // Select all elements with the class .noUi-handle.noUi-handle-lower
  const lowerHandles = document.querySelectorAll('.noUi-handle.noUi-handle-lower');
  const upperHandles = document.querySelectorAll('.noUi-handle.noUi-handle-upper');

  // Loop through each .noUi-handle.noUi-handle-lower and add aria-label="slider lower"
  lowerHandles.forEach(function(handle) {
    handle.setAttribute('aria-label', 'slider lower');
  });

  // Loop through each .noUi-handle.noUi-handle-upper and add aria-label="slider upper"
  upperHandles.forEach(function(handle) {
    handle.setAttribute('aria-label', 'slider upper');
  });
});


document.addEventListener('DOMContentLoaded', function() {
  // Select all images on the page
  const images = document.querySelectorAll('img');

  // Loop through each image
  images.forEach(function(image) {
    // Check if the image does not have an alt attribute
    if (!image.hasAttribute('alt')) {
      // Add an empty alt attribute
      image.setAttribute('alt', '');
    }
  });
});


document.addEventListener('DOMContentLoaded', function() {
  // Select all links with href="#looxReviews"
  const links = document.querySelectorAll('a[href="#looxReviews"]');

  // Loop through each link to check if #looxReviews is linked
  links.forEach(function(link) {
    // Now check if the element with class .loox-rating exists
    const looxReviewsElement = document.querySelector('.loox-rating'); // Class selector for .loox-rating
    
    if (looxReviewsElement) {
      // If the .loox-rating element exists, add aria-label="reviews with stars"
      looxReviewsElement.setAttribute('aria-label', 'reviews with stars');

      // Create a new span element with class "visually-hidden"
      const visuallyHiddenSpan = document.createElement('span');
      visuallyHiddenSpan.classList.add('visually-hidden');
      visuallyHiddenSpan.textContent = 'review with stars';

      // Append the span inside the .loox-rating element
      looxReviewsElement.appendChild(visuallyHiddenSpan);
    }
  });
});


document.addEventListener('DOMContentLoaded', function() {
  // Select all images inside elements with the class .scrolling-text__item
  const images = document.querySelectorAll('.scrolling-text__item img');

  // Loop through each image and set the alt text with its index
  images.forEach(function(image, index) {
    // Set the alt attribute with "Get your waggle on (index + 1)"
    image.setAttribute('alt', `Get your waggle on (${index + 1})`);
  });
});


document.addEventListener('DOMContentLoaded', function() {
  // Select all <h5> elements inside the given selector
  const headings = document.querySelectorAll('.tabbed-content.tabbed-content.text-width-grid.tabs-center h5, .blog-post h5');

  // Loop through each <h5> element and set the aria-level="2"
  headings.forEach(function(heading) {
    heading.setAttribute('aria-level', '2');
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // Select all <h3>, <h4>, and <h5> elements inside elements with the class .shopify-policy__body
  const headings = document.querySelectorAll('.shopify-policy__body h3, .shopify-policy__body h4, .shopify-policy__body h5');

  // Loop through each heading and set the aria-level="2"
  headings.forEach(function(heading) {
    heading.setAttribute('aria-level', '2');
  });
});


document.addEventListener('DOMContentLoaded', function () {
    // Select the anchor element using its href
    var link = document.querySelector('a[href="https://apps.apple.com/us/app/waggle-apparel-accessories/id6502953220"]');

    // If the link exists, add the aria-label attribute
    if (link) {
        link.setAttribute('aria-label', 'Download on the App Store, this link opens in new window');
    } else {
        console.log('Link not found.');
    }
});

document.addEventListener('DOMContentLoaded', function () {
    // Select the anchor element with the given href
    var link = document.querySelector('a[href="https://play.google.com/store/apps/details?id=co.app.id_hKx2dWp93i&hl=en_US"]');

    // If the link exists, add the aria-label attribute and set target="_blank"
    if (link) {
        link.setAttribute('aria-label', 'Get It On Google Play, this link opens in new window');
        link.setAttribute('target', '_blank');  // Open the link in a new tab
    } else {
        console.log('Link not found.');
    }
});





//umr
document.addEventListener('DOMContentLoaded', function () {
    // Select all menu items that have submenus
    var menuItemsWithSubmenus = document.querySelectorAll('.menu-item-has-children');

    menuItemsWithSubmenus.forEach(function (menuItem) {
        // Find the <a> tag inside the menu item (this is the clickable link)
        var link = menuItem.querySelector('a');

        if (link) {
            // Set aria-expanded to 'false' initially for all links
            link.setAttribute('aria-expanded', 'false');
            // Set role="button" to indicate this is a clickable button
            link.setAttribute('role', 'button');

            // Add click event listener to toggle the submenu
            link.addEventListener('click', function (event) {
                event.preventDefault(); // Prevent the default behavior of the link

                // Find the submenu associated with this menu item
                var submenu = menuItem.querySelector('.sub-menu, .mega-menu-container');
                if (submenu) {
                    // Toggle the 'active' class on the submenu to show/hide it
                    submenu.classList.toggle('active');

                    // Toggle the aria-expanded attribute to reflect the menu's open/close state
                    var isExpanded = submenu.classList.contains('active');
                    link.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
                }

                // Close only sibling submenus (if you only want one open at a time within the same level)
                var siblingSubmenus = Array.from(
                    menuItem.parentElement.querySelectorAll('.sub-menu.active, .mega-menu-container.active')
                ).filter(function (otherSubmenu) {
                    return otherSubmenu !== submenu;
                });

                siblingSubmenus.forEach(function (otherSubmenu) {
                    otherSubmenu.classList.remove('active');
                    var otherLink = otherSubmenu.closest('.menu-item-has-children').querySelector('a');
                    if (otherLink) {
                        otherLink.setAttribute('aria-expanded', 'false');
                    }
                });
            });
        }
    });
});
